import store from "@/store"
export default {
    methods: {
        commitLanguageStore(newLocale) {
            this.$i18n.locale = newLocale;
            store.commit('setLanguage', newLocale);
        },
        goIframe(link) {
            if (link !== null && link.trim() !== "") {
                if (link.includes("content")) {
                    const strIndex = link.indexOf("com/", 1)
                    const iframePath = link.slice(strIndex + 4)
                    window.open(iframePath, "_self");
                } else {
                    const strIndex = link.indexOf("com/", 1)
                    const iframePath = encodeURIComponent(link.slice(strIndex + 4) + '/lang/' + this.switchLangCase(this.$i18n.locale))
                    window.open(iframePath, "_self");
                }

            } else {
                return false;
            }
        },
        goNews(id) {
            window.open("/news/" + id);
        },
        clickMenu(link) {
            if (link !== null) {
                if (link.length > 1 && link == this.$iframeUrl + "/investorRelation") {
                    return {
                        name: 'iframe',
                        params: {
                            iframePath: 'investorRelation'
                        }
                    }
                }
                else if (link.length > 1) {
                    const strIndex = link.indexOf("com/", 1)
                    return {
                        name: 'iframe',
                        params: {
                            iframePath: link.slice(strIndex + 4) + '/lang/' + this.switchLangCase(this.$i18n.locale)
                        }
                    }
                } else {
                    return this.$route.path
                }
            } else {
                return this.$route.path
            }
        },
        clickMenuId(rootItem, secondItem) {
            if (rootItem != null) {
                if (secondItem.status == 1) {
                    const rootPath = rootItem.languageFamilyList.find(obj => obj.lang == "EN_US").content;
                    if (secondItem.link !== null) {
                        if (secondItem.link == 'news') {
                            return { name: 'news' }
                        } else {
                            return {
                                name: 'content',
                                params: {
                                    rootPageName: rootPath.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-'),
                                    pageId: secondItem.id
                                    // contentPath: rootPath + '/' + secondItem.id
                                }
                            }
                        }
                    }
                    else {
                        return this.$route.path
                    }
                } else {
                    return this.clickMenu(secondItem.link);
                }
            } else {
                if (secondItem.link == '/investorRelation') {
                    return { name: 'ir' }
                } else {
                    return this.clickMenu(secondItem.link);
                }
            }
        },
        clickMenuCollapse(link) {
            if (link !== null) {
                if (link.length > 1 && link == this.$iframeUrl + "/investorRelation") {
                    return {
                        name: 'iframe',
                        params: {
                            iframePath: 'investorRelation'
                        }
                    }
                }
                else if (link.length > 1) {
                    const strIndex = link.indexOf("com/", 1)
                    return {
                        name: 'iframe',
                        params: {
                            iframePath: link.slice(strIndex + 4) + '/lang/' + this.switchLangCase(this.$i18n.locale)
                        }
                    }
                } else {
                    return this.$route.path
                }
            } else {
                return this.$route.path
            }
        },
        clickFooter(rootItem, secondItem) {
            if (secondItem.status == 1) {
                const rootPath = rootItem.languageFamilyList.find(obj => obj.lang == "EN_US").content;
                if (secondItem.link !== null) {
                    if (secondItem.link == 'news') {
                        return { name: 'news' }
                    } else {
                        return {
                            name: 'content',
                            params: {
                                rootPageName: rootPath.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-'),
                                pageId: secondItem.id
                                // contentPath: rootPath + '/' + secondItem.id
                            }
                        }
                    }
                }
                if (secondItem.subMenu.length > 0) {
                    return {
                        name: 'content',
                        params: {
                            rootPageName: secondItem.languageFamilyList.find(obj => obj.lang == "EN_US").content.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-'),
                            pageId: secondItem.subMenu[0].id
                            // contentPath: secondItem.languageFamilyList.find(obj => obj.lang == "EN_US").content + '/' + secondItem.subMenu[0].id
                        }
                    }
                }
            } else {
                if (secondItem.subMenu[0] == undefined) {
                    return this.clickMenu(rootItem.link);
                }
                else {

                    return this.clickFooter(secondItem, secondItem.subMenu[0]);
                }
            }
        },
        clickCookie(link) {
            return {
                name: 'iframe',
                params: {
                    iframePath: link + '/lang/' + this.switchLangCase(this.$i18n.locale)
                }
            }
        },
        clickNewsTitle() {
            const strIndex = this.$newsUrl.indexOf("com/", 1)
            return {
                name: 'iframe',
                params: {
                    iframePath: this.$newsUrl.slice(strIndex + 4) + '/lang/' + this.switchLangCase(this.$i18n.locale)
                }
            }
        },
        switchLangCase(lang) {
            return lang.substr(0, 2).toLowerCase() + lang.substr(2);
        },
        go(href) {
            window.open(href, "_self");
        },
        handleClickLogo(event) {
            if (this.$route && this.$route.path === '/') {
                event.preventDefault(); // 阻止默認行為
                window.slidePage.index(1);
            }
        },
        handleClickLogoByDiv(event) {
            if (this.$route && this.$route.path === '/') {
                event.preventDefault(); // 阻止默認行為
                window.slidePage.index(1);
            } else {
                this.go('/')
            }
        }
    }
}